
import { useState } from 'react';
import ContactFormPopup from '../../../components/feature/ContactFormPopup';

export default function Footer() {
  const [isFormPopupOpen, setIsFormPopupOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContactClick = () => {
    setIsFormPopupOpen(true);
  };

  return (
    <>
      <footer className="bg-gradient-to-br from-teal-500 via-green-500 to-yellow-400 text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Brand Section */}
            <div>
              <h3 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Fredoka, system-ui, sans-serif' }}>
                Can-do Crew
              </h3>
              <p className="text-white/90 mb-4">
                Making trash can cleaning fun and easy! We keep your bins sparkling clean so you don't have to.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-xl"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-xl font-bold mb-4" style={{ fontFamily: 'Fredoka, system-ui, sans-serif' }}>
                Quick Links
              </h4>
              <ul className="space-y-3">
                <li>
                  <button onClick={() => window.REACT_APP_NAVIGATE('/')} className="hover:text-yellow-300 transition-colors cursor-pointer text-left">
                    Home
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('pricing')} className="hover:text-yellow-300 transition-colors cursor-pointer text-left">
                    Pricing
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('services')} className="hover:text-yellow-300 transition-colors cursor-pointer text-left">
                    Services
                  </button>
                </li>
                <li>
                  <button onClick={() => window.REACT_APP_NAVIGATE('/reviews')} className="hover:text-yellow-300 transition-colors cursor-pointer text-left">
                    Reviews
                  </button>
                </li>
                <li>
                  <button onClick={() => window.REACT_APP_NAVIGATE('/gallery')} className="hover:text-yellow-300 transition-colors cursor-pointer text-left">
                    Gallery
                  </button>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="text-xl font-bold mb-4" style={{ fontFamily: 'Fredoka, system-ui, sans-serif' }}>
                Company
              </h4>
              <ul className="space-y-3">
                <li>
                  <button onClick={() => scrollToSection('about')} className="hover:text-yellow-300 transition-colors cursor-pointer text-left">
                    About Us
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('about')} className="hover:text-yellow-300 transition-colors cursor-pointer text-left">
                    Our Team
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-xl font-bold mb-4" style={{ fontFamily: 'Fredoka, system-ui, sans-serif' }}>
                Contact Info
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold">Phone</p>
                    <a href="tel:+15551234567" className="hover:text-yellow-300 transition-colors">
                      (501)236-2116
                    </a>
                  </div>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold">Email</p>
                    <a href="mailto:yourcandocrew@gmail.com" className="hover:text-yellow-300 transition-colors">
                      yourcandocrew@gmail.com
                    </a>
                  </div>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-xl mt-1"></i>
                  <div>
                    <p className="font-semibold">Service Area</p>
                    <p className="text-white/90">Select Searcy Neighborhoods</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/80 text-sm">
              © 2025 Can-do Crew. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="hover:text-yellow-300 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-yellow-300 transition-colors">Terms of Service</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-300 transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Contact Form Popup */}
      <ContactFormPopup
        isOpen={isFormPopupOpen}
        onClose={() => setIsFormPopupOpen(false)}
      />
    </>
  );
}
